module.exports = __webpack_public_path__ + "static/visit-1-2d539a75459215f4db36934002d8a035.jpg";